import { Injectable } from '@angular/core';
import { VehicleServiceBase } from 'scaletech-vehicles';
import { HttpClient } from '@angular/common/http';
import { WebApiService } from 'starbase-login';

@Injectable({
  providedIn: 'root'
})
export class VehicleDataService extends VehicleServiceBase {

  constructor(http: HttpClient, webApi: WebApiService) {
    super(http, webApi);
  }
}
